import { Component, Input, OnInit } from '@angular/core';
import { BackgroundModel, Button, EventsService, RedirectionLinkType } from 'simpo-component-library';
import { ProductServiceService } from 'src/app/master-config-components/micro-apps/products/service/product-service.service';
import { DbService } from 'src/app/services/db-service/db.service';

interface TypeOption {
  type: RedirectionLinkType;
}

const GradientDirectionMap: Record<string, string> = {
  DOWN:           '180deg',
  RIGHT:          '90deg',
  DIAGONAL_RIGHT: '45deg',
  DIAGONAL_LEFT:  '135deg'
};

@Component({
  selector: 'app-button-editor',
  templateUrl: './button-editor.component.html',
  styleUrls: ['./button-editor.component.scss']
})
export class ButtonEditorComponent implements OnInit {

  constructor(
    private eventService: EventsService,
    private productService: ProductServiceService,
    private _dbService: DbService,
  ) {}

  @Input() buttonData: Button = {
    linkType: RedirectionLinkType.External,
    label: '',
    redirectionUrl: '',
    pageId: '',
    newTab: false
  };
  @Input() buttonStyle: any;
  @Input() componentId: string = '';
  @Input() btnId: string = '';
  @Input() color: string = '';
  @Input() backgroundInfo?: BackgroundModel;
  @Input() embedded: boolean = false;
  @Input() templatePage: any[] = [];
  @Input() currentPageIndex: number = 0;

  get bs(): any { return this.buttonStyle as any; }

  backgroundType: string[] = ['Solid', 'Gradient'];

  tabs = [
    { name: 'CONTENT', label: 'Content', status: true },
    { name: 'STYLES', label: 'Styles', status: false }
  ];
  selectedTab: string = 'CONTENT';

  tabShift(name: string): void {
    this.tabs.forEach(t => t.status = t.name === name);
    this.selectedTab = name;
  }

  buttonTypes = [
    { type: 'Solid' },
    { type: 'Outline' },
    { type: 'Text' }
  ];

  buttonShapes = [
    {
      type: 'Square',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/832968c1747221270856Vector%2048%20(2).png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/481850c1747220937693Vector%2048%20(1).png'
    },
    {
      type: 'Curve',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/830842c1747220757453Vector%2049.png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/780601c1747221243613Vector%2049%20(1).png'
    },
    {
      type: 'Round',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/210350c1747220803521Vector%2050.png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/939611c1747220900124Vector%2050%20(1).png'
    }
  ];

  directionType = [
    {
      type: 'DOWN',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/664403c1747306840304arrow-down.png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/587430c1747306898465arrow-down.png'
    },
    {
      type: 'RIGHT',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/193359c1747306949522arrow-right.png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/450943c1747317759388arrow-right%20(2).png'
    },
    {
      type: 'DIAGONAL_RIGHT',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/493838c1747307094821arrow-right%20(3).png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/699932c1747307157944arrow-right%20(4).png'
    },
    {
      type: 'DIAGONAL_LEFT',
      icon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/911971c1747307199115arrow-right%20(5).png',
      activeIcon: 'https://d2yx15pncgmu63.cloudfront.net/prod-images/968726c1747307227255arrow-right%20(6).png'
    }
  ];

  RedirectionLink = RedirectionLinkType;

  RedirectionLinkType: Array<TypeOption> = [
    { type: RedirectionLinkType.Page },
    { type: RedirectionLinkType.External },
    { type: RedirectionLinkType.Email },
    { type: RedirectionLinkType.Phone },
    { type: RedirectionLinkType.section }
  ];

  currentPageName: string = '';
  collectionList: any[] = [];
  categoryList: any[] = [];
  collectionPath: string = '';
  categoryPath: string = '';

  ngOnInit() {
    if (this.buttonData?.linkType === RedirectionLinkType.Page && this.buttonData?.redirectionUrl &&
      (this.buttonData.redirectionUrl.includes('collections=') || this.buttonData.redirectionUrl.includes('category='))) {
      this.currentPageName = 'Product List';
      this.loadProductListData();
      this.parseProductListSelection(this.buttonData.redirectionUrl);
    }
    if (!this.buttonStyle) {
      this.buttonStyle = {
        type: 'Solid',
        colorType: 'Solid',
        background: '#000000',
        secondaryBackground: '#444444',
        textColor: '#FFFFFF',
        gradientDirection: 'DOWN',
        shape: 'Curve'
      };
    } else {
      if (!this.buttonStyle.type)                this.buttonStyle.type               = 'Solid';
      if (!this.buttonStyle.colorType)           this.buttonStyle.colorType          = 'Solid';
      if (!this.buttonStyle.background)          this.buttonStyle.background         = '#000000';
      if (!this.buttonStyle.secondaryBackground) this.buttonStyle.secondaryBackground = '#444444';
      if (!this.buttonStyle.textColor)           this.buttonStyle.textColor          = '#FFFFFF';
      if (!this.buttonStyle.gradientDirection)   this.buttonStyle.gradientDirection  = 'DOWN';
      if (!this.buttonStyle.shape)               this.buttonStyle.shape              = 'Curve';
    }
    this.syncBackgroundType();
  }

  private syncBackgroundType() {
    if (this.buttonStyle.type === 'Outline' || this.buttonStyle.type === 'Text') {
      this.backgroundType = ['Solid'];
      this.buttonStyle.colorType = 'Solid';
    } else {
      this.backgroundType = ['Solid', 'Gradient'];
    }
  }

  changeButtonStyle() {
    this.syncBackgroundType();
    this.eventService.buttonStyleChangeChecks.emit({
      id: this.componentId + this.btnId,
      style: this.buttonStyle,
      backgroundInfo: this.backgroundInfo
    });
  }

  getContrastTextColor(hex: string) {
    const clean = hex?.replace('#', '').padEnd(6, '0');
    const r = parseInt(clean.substr(0, 2), 16) / 255;
    const g = parseInt(clean.substr(2, 2), 16) / 255;
    const b = parseInt(clean.substr(4, 2), 16) / 255;
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    this.buttonStyle.textColor = luminance < 0.5 ? '#FFFFFF' : '#000000';
    this.changeButtonStyle();
  }

  getColorLabel(): string {
    if (this.buttonStyle?.type === 'Outline') return 'Outline Color';
    if (this.buttonStyle?.type === 'Text')    return 'Text Color';
    return 'Button Color';
  }

  setBorderRadius(): string {
    if (this.buttonStyle?.type === 'Text')    return '0px';
    if (this.buttonStyle?.shape === 'Square') return '0px';
    if (this.buttonStyle?.shape === 'Curve')  return '7px';
    if (this.buttonStyle?.shape === 'Round')  return '99px';
    return '0px';
  }

  setBorder(): string {
    if (this.buttonStyle?.type === 'Outline') return `2px solid ${this.buttonStyle?.background}`;
    return 'unset';
  }

  setBackground(): string {
    if (this.buttonStyle?.colorType === 'Solid' && this.buttonStyle?.type === 'Solid') {
      return this.buttonStyle?.background;
    }
    if (this.buttonStyle?.colorType === 'Gradient' && this.buttonStyle?.type === 'Solid') {
      const cssDeg = GradientDirectionMap[this.buttonStyle.gradientDirection] ?? '180deg';
      return `linear-gradient(${cssDeg}, ${this.buttonStyle?.background}, ${this.buttonStyle?.secondaryBackground})`;
    }
    return '';
  }

  setColor(): string {
    return this.buttonStyle?.textColor || '#ffffff';
  }

  onPageChange(page: any) {
    this.buttonData.redirectionUrl = page.path;
    this.buttonData.pageId = page.id;
    this.currentPageName = page.pageName;
    this.collectionPath = '';
    this.categoryPath = '';
    if (this.currentPageName === 'Product List') {
      this.loadProductListData();
    }
  }

  loadProductListData() {
    const businessId = this._dbService.getBusinessId();
    this.productService.getCollectionList({ businessId, pageNo: 0, pageSize: 100 }).subscribe({
      next: (res: any) => { this.collectionList = res?.data?.data ?? []; }
    });
    this.productService.getcategoriesList({ businessId, searchText: '', pageNo: 0, pageSize: 1000 }).subscribe({
      next: (res: any) => { this.categoryList = res?.data?.data ?? []; }
    });
  }

  private parseProductListSelection(url: string) {
    const query = url.split('?')[1];
    if (!query) return;
    const params = new URLSearchParams(query);
    this.collectionPath = params.get('collections') ?? '';
    this.categoryPath = params.get('category') ?? '';
  }

  addCollectionToPath() {
    this.rebuildProductListUrl();
  }

  addCategoryToPath() {
    this.rebuildProductListUrl();
  }

  // Deterministically rebuild the query string from the current collection/category
  // selections so changing/clearing either never duplicates or strips a param.
  private rebuildProductListUrl() {
    const base = (this.buttonData.redirectionUrl || '').split('?')[0];
    const parts: string[] = [];
    if (this.collectionPath) parts.push('collections=' + this.collectionPath);
    if (this.categoryPath) parts.push('category=' + this.categoryPath);
    this.buttonData.redirectionUrl = parts.length ? base + '?' + parts.join('&') : base;
  }
}
